"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clean = void 0;
function clean(hrefWithoutOrigin) {
    var m = hrefWithoutOrigin.match(/^(\/[^?#]*)(.*)$/);
    if (!m)
        throw new Error("Unexpected href " + hrefWithoutOrigin);
    var path = m[1], query = m[2];
    return (path.replace(/\/{2,}/g, "/").replace(/(.)\/$/g, "$1") +
        query.replace(/[?#&=]+$/g, ""));
}
exports.clean = clean;
//# sourceMappingURL=clean.js.map